import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeAuthenticatedComponent } from "./home-authenticated/home-authenticated.component";
import { HomeUnauthenticatedComponent } from "./home-unauthenticated/home-unauthenticated.component";
import { RegisterComponent } from "./register/register.component";
import { LoginComponent } from "./login/login.component";
import { ProfileComponent } from './profile/profile.component';
import { CreateRoleComponent } from './create-role/create-role.component';
import { ListRolesComponent } from './list-roles/list-roles.component';
import { EditRoleComponent } from './edit-role/edit-role.component';
import { EditUsersInRoleComponent } from './edit-users-in-role/edit-users-in-role.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ContactComponent } from './contact/contact.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { HelpCenterComponent } from './help-center/help-center.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: HomeUnauthenticatedComponent,
    title: 'Meal Planner - Unauthenticated',
  },
  {
    path: 'home',
    component: HomeAuthenticatedComponent,
    title: 'Meal Planner - Authenticated',
  },
  {
    path: 'register',
    component: RegisterComponent,
    title: 'Meal Planner - Register'
  },
  {
    path: 'login',
    component: LoginComponent,
    title: 'Meal Planner - Login'
  },
  {
    path: 'profile',
    component: ProfileComponent,
    title: 'Meal Planner - User Profile'
  },
  {
    path: 'create_role',
    component: CreateRoleComponent,
    title: 'Meal Planner - Create New Role'
  },
  {
    path: 'list_roles',
    component: ListRolesComponent,
    title: 'Meal Planner - Roles List'
  },
  {
    path: 'edit_role',
    component: EditRoleComponent,
    title: 'Meal Planner - Edit Role'
  },
  {
    path: 'edit_users_in_role',
    component: EditUsersInRoleComponent,
    title: 'Meal Planner - Edit Users in Role'
  },
  {
    path: 'privacy_policy',
    component: PrivacyPolicyComponent,
    title: 'Meal Planner - Privacy Policy'
  },
  {
    path: 'contact',
    component: ContactComponent,
    title: 'Meal Planner - Contact Us'
  },
  {
    path: 'password_reset',
    component: PasswordResetComponent,
    title: 'Meal Planner - Password Reset'
  },
  {
    path: 'help_center',
    component: HelpCenterComponent,
    title: 'Meal Planner - Help Center'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
